<template>
  <div class="render-list">
    <CommonHeader :curNavIndex="curNavIndex"></CommonHeader>
    <CommonSearch></CommonSearch>
    <div id="wrapper" class="iscroll-list painter-list">
      <div id="scroller">
        <div id="J_PullDown" class="ui-refresh-down" style="display:none;"><span class="refresh-down-label"></span></div>
        <ul id="thelist">
          <img class="loading-img" src="../../static/img/loading.gif">
        </ul>
        <div id="J_PullUp" class="ui-refresh-up" style="display:none;"><span class="refresh-up-label">More</span><img class="pull-up-img" src="../../static/img/loading.gif"></div>
      </div>
    </div>
    <CommonFooter></CommonFooter>
    <div id="J_ErrorTip" class="error-tip"></div>
  </div>
</template>
<script>
  import axios from 'axios';
  import {API_LIST} from '../utils/config';
  import CommonHeader from './Header';
  import CommonSearch from './Search';
  import CommonFooter from './Footer';
  import {loaded, renderData} from '../utils/refresh';

  export default {
    name: 'Painter',
    components: {
      CommonHeader,
      CommonSearch,
      CommonFooter
    },
    data () {
      return {
        curNavIndex: 0,
        errorImgUrl: '../../static/img/error.png',
        pageInfo:{page: 1, pageSize: 5}
      }
    },
    methods: {
      getPainterList: function(){
        var formData = JSON.stringify(this.pageInfo);

        axios.post(API_LIST.painterList, JSON.parse(formData))
          .then(res => {
            if (res.data.status.error_code === 0) {
              let currentPage = res.data.pageinfo.cur_page;

              //上拉标识符(首屏，非首屏的标识符)
              if(currentPage > 1){
                $('#J_PullUp').find('.pull-up-img').hide();
              }

              let strHtml = '';

              for(let item of res.data.bizobj){
                strHtml = strHtml + (`<li>
                  <div class="item-content">
                  <div class="content-hd"><a href="/#/painterDetail/${item.id}"><div class="name">${item.name}</div><div class="detail-link"><div class="right-arrow"></div></div></a></div>
                  <div class="content-ft">
                  ${item.workList.map(work => `
                    <div class="work-list"><a href="/#/workDetail/${work.workId}"><img src="${work.imgUrl}" onerror="this.src='${this.errorImgUrl}';"/></a></div>
                  `).join('')}
                  </div>
                  </div>
                  </li>`);
              }

              if(currentPage > 1){
                $('#thelist').append(strHtml);
              }else{
                $('#thelist').html(strHtml);
              }

              setTimeout(() => {myScroll.refresh();}, 200);

              $('#J_CommonFooter').show();

              this.pageInfo.page = currentPage + 1;

              if(this.pageInfo.page > res.data.pageinfo.max_page || res.data.pageinfo.max_page === 1){
                $('#J_PullUp').hide()
              }else{
                $('#J_PullUp').find('.refresh-up-label').html('More');

                $('#J_PullUp').show()
              }
             }else{
              $('#J_PullUp').hide();

              // if(res.data.pageinfo.cur_page > 1){
              //   $('#thelist').append('<div class="empty-data">'+ res.data.status.error_msg + '</div>');
              // }else{
              //   $('#thelist').html('<div class="empty-data">'+ res.data.status.error_msg +'</div>');
              // }

              setTimeout(() => {myScroll.refresh();}, 200);

              $('#J_CommonFooter').show();
            }
          }).catch(err => {
            console.log(err);
          });
      }
    },
    created: function(){
      setTimeout(loaded, 200);
    },
    mounted: function(){
      renderData(this.getPainterList);
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Painter.vue?a7f3d928